<div class="basket containerBaskBooking" [ngClass]="{'show': count > 0}" (click)="openModal()">
  <mat-icon>add_alarm</mat-icon>
  <div class="puce">{{count}}</div>
</div>
